const reactModule = (Component, nodeList) => {
  const React = require('react');
  const { render } = require('react-dom');

  nodeList.forEach(node => render(<Component {...node.dataset} />, node));
};

export default [
  { name: 'inputField', loader: () => import('./components/inputField') },
  { name: 'inputFile', loader: () => import('./components/inputFile') },
  { name: 'inputDate', loader: () => import('./components/inputDate') },
  { name: 'dropdown', loader: () => import('./components/dropdown') },
  { name: 'backToTop', loader: () => import('./components/backToTop') },
  { name: 'header', loader: () => import('./modules/header') },
  {
    name: 'informationAlert',
    loader: () => import('./modules/informationAlert')
  },
  {
    name: 'largeImageCarousel',
    loader: () => import('./modules/largeImageCarousel')
  },
  { name: 'ctaGrouping', loader: () => import('./modules/ctaGrouping') },
  {
    name: 'largeImageScurve',
    loader: () => import('./modules/largeImageScurve')
  },
  {
    name: 'flexibleImageCarousel',
    loader: () => import('./modules/flexibleImageCarousel')
  },
  { name: 'accordion', loader: () => import('./modules/accordion') },
  { name: 'cookieWarning', loader: () => import('./modules/cookieWarning') },
  { name: 'brandsMenu', loader: () => import('./modules/brandsMenu') },
  { name: 'aboutUsTabs', loader: () => import('./modules/aboutUsTabs') },
  { name: 'imageGrouping', loader: () => import('./modules/imageGrouping') },
  {
    name: 'relatedArticles',
    loader: () => import('./modules/relatedArticles')
  },
  {
    name: 'largeImageCtaGrouping',
    loader: () => import('./modules/largeImageCtaGrouping')
  },
  { name: 'gallery', loader: () => import('./modules/gallery') },
  { name: 'goalTracker', loader: () => import('./modules/goalTracker') },
  {
    name: 'locationFinder',
    loader: () => import('./modules/locationFinder'),
    render: reactModule
  },
  {
    name: 'brandSelector',
    loader: () => import('./modules/brandSelector'),
    render: reactModule
  },
  {
    name: 'giftCardListing',
    loader: () => import('./modules/giftCardListing'),
    render: reactModule
  },
  {
    name: 'pressRoom',
    loader: () => import('./modules/pressRoom'),
    render: reactModule
  },
  {
    name: 'brandListing',
    loader: () => import('./modules/brandListing'),
    render: reactModule
  },
  {
    name: 'searchResults',
    loader: () => import('./modules/searchResults'),
    render: reactModule
  }
];
